import { createReducer, on } from '@ngrx/store';
import * as OrganizationActions from '../actions/organization.actions';
import { OrganizationState, ValidationStatusEnum } from '../../shared/models';

export const initialState: OrganizationState = {
  organizationTableLoading: false,
  userTableLoading: false,
  treeTableLoading: false,
  deletedGroupsTableLoading: false,
  deletedGroupsCount: 0,
  orphanGroupsTableLoading: false,
  orphanGroupsCount: 0,
  users: [],
  selectedUserIds: [],
  tree: [],
  companyAttributes: [],
  error: null,
  errorTree: null,
  activeHierarchy: 0,
  validationStatus: ValidationStatusEnum.idle,
  fields: []
};

export const reducer = createReducer(
  initialState,
  on(OrganizationActions.OrganizationTreeTableLoading, (state) => ({
    ...state,
    organizationTableLoading: true,
  })),
  on(OrganizationActions.OrganizationTreeTableLoadingComplete, (state) => ({
    ...state,
    organizationTableLoading: false,
  })),

  on(OrganizationActions.UserTableLoading, (state) => ({
    ...state,
    userTableLoading: true,
  })),
  on(OrganizationActions.UserTableLoadingComplete, (state) => ({
    ...state,
    userTableLoading: false,
  })),

  on(OrganizationActions.DeletedGroupsTableLoading, (state) => ({
    ...state,
    deletedGroupsTableLoading: true,
  })),
  on(OrganizationActions.DeletedGroupsTableLoadingComplete, (state) => ({
    ...state,
    deletedGroupsTableLoading: false,
  })),
  on(OrganizationActions.SetDeletedGroupsCount, (state, { payload }) => ({
    ...state,
    deletedGroupsCount: payload,
  })),

  on(OrganizationActions.OrphanGroupsTableLoading, (state) => ({
    ...state,
    orphanGroupsTableLoading: true,
  })),
  on(OrganizationActions.OrphanGroupsTableLoadingComplete, (state) => ({
    ...state,
    orphanGroupsTableLoading: false,
  })),
  on(OrganizationActions.SetOrphanGroupsCount, (state, { payload }) => ({
    ...state,
    orphanGroupsCount: payload,
  })),

  on(OrganizationActions.fetchGroupUsers, (state) => ({
    ...state,
    userTableLoading: true,
    error: null,
  })),
  on(OrganizationActions.fetchUsers, (state) => ({
    ...state,
    userTableLoading: true,
    error: null,
  })),
  on(OrganizationActions.fetchUsersSuccess, (state, { users }) => ({
    ...state,
    userTableLoading: false,
    users: users,
    error: null,
  })),
  on(OrganizationActions.fetchUsersError, (state, { error }) => ({
    ...state,
    userTableLoading: false,
    users: [],
    error: error,
  })),

  on(OrganizationActions.selectUsers, (state, { ids }) => ({
    ...state,
    selectedUserIds: [...new Set([...state.selectedUserIds, ...ids])],
  })),

  on(OrganizationActions.deselectUsers, (state, { ids }) => ({
    ...state,
    selectedUserIds: state.selectedUserIds.filter((id) => !ids.includes(id)),
  })),

  on(OrganizationActions.fetchTree, (state) => ({
    ...state,
    treeTableLoading: true,
    errorTree: null,
  })),
  on(OrganizationActions.fetchTreeSuccess, (state, { tree }) => ({
    ...state,
    treeTableLoading: false,
    tree: tree,
    errorTree: null,
  })),
  on(OrganizationActions.fetchTreeError, (state, { error }) => ({
    ...state,
    treeTableLoading: false,
    tree: [],
    errorTree: error,
  })),

  on(OrganizationActions.fetchCompanyAttributesSuccess, (state, { attributes }) => ({
    ...state,
    companyAttributes: attributes
  })),
  on(OrganizationActions.fetchCompanyAttributesError, (state, { error }) => ({
    ...state,
    error: error,
  })),

  on(OrganizationActions.validateUser, (state) => ({
    ...state,
    validationStatus: ValidationStatusEnum.validating
  })),
  on(OrganizationActions.validateUserSuccess, (state, { fields }) => ({
    ...state,
    fields: fields,
    validationStatus: ValidationStatusEnum.valid
  })),
  on(OrganizationActions.validateUserFailed, (state, { fields }) => ({
    ...state,
    fields: fields,
    validationStatus: ValidationStatusEnum.invalid
  })),
  on(OrganizationActions.validateUserError, (state, { error }) => ({
    ...state,
    validationStatus: ValidationStatusEnum.error
  })),

  on(OrganizationActions.addUserSuccess, (state, { user }) => ({
    ...state,
    users: [...state.users, user],
    validationStatus: ValidationStatusEnum.idle
  })),
  on(OrganizationActions.addUserError, (state, { error }) => ({
    ...state,
    error: error,
  })),

  on(OrganizationActions.editUserSuccess, (state, { user }) => ({
    ...state,
    users: state.users.map(u => u.id === user.id ? user : u),
    validationStatus: ValidationStatusEnum.idle
  })),
  on(OrganizationActions.editUserError, (state, { error }) => ({
    ...state,
    error: error,
  })),

  on(OrganizationActions.selectHierarchy, (state, { id }) => ({
    ...state,
    activeHierarchy: id
  })),
  
);
